import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import displayBrokerType from 'dashboard/lib/valueDisplayers/reportFinraBrokerCheck';
import {
  FinraBrokerCheckBrokerType,
  ReportFinraBrokerCheck,
} from 'dashboard/models/report/finra-broker-check';

interface FinraBrokerCheckProps {
  report: ReportFinraBrokerCheck;
  isRedacted: boolean;
}

export const FinraBrokerCheck = ({ report }: FinraBrokerCheckProps) => {
  const {
    'broker-type': brokerType,
    'crd-number': crdNumber,
    'name-full': nameFull,
    'firm-name': firmName,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
  } = report.attributes;

  const brokerTypeIsIndividual = brokerType === FinraBrokerCheckBrokerType.Individual;

  return (
    <AttributeGrid>
      <AttributeItem
        title='Broker type'
        value={displayBrokerType(brokerType)}
        placeholder='N/A'
        dataTest='report-finra-broker-check__broker-type'
      />
      <AttributeItem
        title='CRD#'
        value={crdNumber}
        placeholder='N/A'
        dataTest='report-finra-broker-check__crd-number'
      />
      {brokerTypeIsIndividual && (
        <AttributeItem
          title='Full name'
          value={nameFull}
          placeholder='N/A'
          dataTest='report-finra-broker-check__name-full'
        />
      )}
      <AttributeItem
        title='Firm name'
        value={firmName}
        placeholder='N/A'
        dataTest='report-finra-broker-check__firm-name'
      />
      <AttributeItem
        title='State'
        value={addressSubdivision}
        placeholder='N/A'
        dataTest='report-finra-broker-check__address-subdivision'
      />
      <AttributeItem
        title='City'
        value={addressCity}
        placeholder='N/A'
        dataTest='report-finra-broker-check__address-city'
      />
    </AttributeGrid>
  );
};
